// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CalendarMonth — shared pick-a-day month grid.
   Colours are the shared redesign palette written out, so the component
   works under both the overview's --ov-* scope and the app shell. */

.rf-cal-month {
  flex-grow: 1;
}
.rf-cal-month-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 12.5px;
  font-weight: 600;
  color: #191714;
}
.rf-cal-spacer {
  flex-grow: 1;
}
.rf-cal-nav {
  background: none;
  border: none;
  font: inherit;
  font-size: 12px;
  line-height: 1;
  color: #a29b8d;
  cursor: pointer;
  padding: 0 4px;
}
.rf-cal-nav:hover {
  color: #191714;
}
.rf-cal-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}
.rf-cal-dow {
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  color: #bdb6a7;
}
.rf-cal-day {
  height: 26px;
  padding: 0;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11.5px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  color: #4a453c;
  font-variant-numeric: tabular-nums;
}
.rf-cal-day:hover {
  background: #f4f1ea;
}
.rf-cal-day.is-empty {
  visibility: hidden;
  cursor: default;
}
.rf-cal-day.in-range {
  background: var(--rf-brand-tint);
  color: var(--rf-brand-deep);
}
.rf-cal-day.is-edge {
  background: var(--rf-brand);
  color: #fff;
  font-weight: 600;
}
/* Today: a ring, so it reads apart from the picked day's fill. When today
   is the picked day the ring sits inside the fill. */
.rf-cal-day.is-today {
  box-shadow: inset 0 0 0 1.5px var(--rf-brand);
  color: var(--rf-brand-deep);
  font-weight: 700;
}
.rf-cal-day.is-today.is-edge {
  box-shadow: inset 0 0 0 1.5px var(--rf-brand), inset 0 0 0 3px #fff;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/CalendarMonth/style.css"],"names":[],"mappings":"AAAA;;oEAEoE;;AAEpE;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;AACA;qDACqD;AACrD;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,mEAAmE;EACnE,WAAW;AACb","sourcesContent":["/* CalendarMonth — shared pick-a-day month grid.\n   Colours are the shared redesign palette written out, so the component\n   works under both the overview's --ov-* scope and the app shell. */\n\n.rf-cal-month {\n  flex-grow: 1;\n}\n.rf-cal-month-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #191714;\n}\n.rf-cal-spacer {\n  flex-grow: 1;\n}\n.rf-cal-nav {\n  background: none;\n  border: none;\n  font: inherit;\n  font-size: 12px;\n  line-height: 1;\n  color: #a29b8d;\n  cursor: pointer;\n  padding: 0 4px;\n}\n.rf-cal-nav:hover {\n  color: #191714;\n}\n.rf-cal-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n.rf-cal-dow {\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 600;\n  color: #bdb6a7;\n}\n.rf-cal-day {\n  height: 26px;\n  padding: 0;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11.5px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #4a453c;\n  font-variant-numeric: tabular-nums;\n}\n.rf-cal-day:hover {\n  background: #f4f1ea;\n}\n.rf-cal-day.is-empty {\n  visibility: hidden;\n  cursor: default;\n}\n.rf-cal-day.in-range {\n  background: var(--rf-brand-tint);\n  color: var(--rf-brand-deep);\n}\n.rf-cal-day.is-edge {\n  background: var(--rf-brand);\n  color: #fff;\n  font-weight: 600;\n}\n/* Today: a ring, so it reads apart from the picked day's fill. When today\n   is the picked day the ring sits inside the fill. */\n.rf-cal-day.is-today {\n  box-shadow: inset 0 0 0 1.5px var(--rf-brand);\n  color: var(--rf-brand-deep);\n  font-weight: 700;\n}\n.rf-cal-day.is-today.is-edge {\n  box-shadow: inset 0 0 0 1.5px var(--rf-brand), inset 0 0 0 3px #fff;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
